import { Checkbox, DatePicker, Input, Select } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { TFunction } from 'i18next';

interface DynamicFieldProps {
  field: any;
  localOptions?: any;
  t: TFunction;
  value?: any;
  onChange?: (value: any, option?: any) => void | Promise<void>;
  checked?: boolean;
  // onChange?: (value: any, option?:any) => void;
}

export const DynamicFieldRenderer: React.FC<DynamicFieldProps> = ({
  field,
  localOptions,
  t,
  ...rest
}) => {
  const selectOptions = localOptions?.[field?.name] || [];

  const handleChange = async (value: any, option?: any) => {
    let val = value;
    if (value?.target) {
      val = field?.type === 'checkbox' ? value.target.checked : value.target.value;
    }

    if (rest.onChange) {
      rest.onChange(val);
    }

    if (field?.onChange) {
      await field?.onChange(val, option);
    }
  };

  switch (field?.type) {
    case 'select':
      return (
        <Select
          {...field}
          {...rest}
          onChange={handleChange}
          placeholder={t(field?.placeholder)}
          showSearch={field?.showSearch || false}
          mode={field?.mode || undefined}
          allowClear={field?.allowClear || false}
          options={selectOptions?.map((opt: any) => ({
            label: t(opt?.label),
            value: opt?.value,
            id: opt?.id,
          }))}
          filterOption={(input, option) =>
            (option?.label ?? '').toString().toLowerCase().includes(input.toLowerCase())
          }
          notFoundContent={t('noData')}
        ></Select>
      );
    case 'textArea':
      return (
        <TextArea
          {...field}
          {...rest}
          placeholder={t(field?.placeholder)}
          rows={4}
          onChange={handleChange}
        />
      );
    case 'date':
      return (
        <DatePicker
          {...field}
          {...rest}
          placeholder={t(field?.placeholder)}
          className="w-full"
          onChange={handleChange}
          inputReadOnly={true}
          // disabledDate={field?.disabledDate}
        />
      );
    case 'checkbox':
      return (
        <Checkbox {...field} {...rest} onChange={handleChange}>
          {t(field?.label)}
        </Checkbox>
      );
    default:
      return (
        <Input {...field} {...rest} placeholder={t(field?.placeholder)} onChange={handleChange} />
      );
  }
};
